/* eslint-disable prettier/prettier */
/*
Style properties 
font: string: name of the font
fontSize: number: size of the font in pt
fontFeatures: string[]: array of advanced typographic features supported in TTF fonts (supported features depend on font file)
lineHeight: number: the line height (default: 1)
bold: boolean: whether to use bold text (default: false)
italics: boolean: whether to use italic text (default: false)
alignment: string: (‘left’ or ‘center’ or ‘right’ or ‘justify’) the alignment of the text
characterSpacing: number: size of the letter spacing in pt
color: string: the color of the text (color name e.g., ‘blue’ or hexadecimal color e.g., ‘#ff5500’)
background: string the background color of the text
markerColor: string: the color of the bullets in a buletted list
decoration: string | string[]: the text decoration to apply (‘underline’ or ‘lineThrough’ or ‘overline’)
decorationStyle: string: the style of the text decoration (‘dashed’ or ‘dotted’ or ‘double’ or ‘wavy’)
decorationColor: string: the color of the text decoration, see color
*/
/*
$this->regularOptions = "fontname=regular fontsize=8 encoding=unicode leading=120% ruler ={100 200 300 400} tabalignment={left left left left} hortabmethod=ruler underline=false ";
        $this->boldOptions = "fontname=bold fontsize=10 encoding=unicode leading=120% ";
        $this->smallBoldOptions = "fontname=bold fontsize=8 encoding=unicode leading=120% ruler ={100 200 300 400} tabalignment={left left left left} hortabmethod=ruler";
        $this->signalColorOption = " fillcolor=" . $this->colors->rgb->headline;
        $this->defaultColorOption = " fillcolor=" . $this->colors->rgb->copy;
        $this->distanceOptions = "fontname=regular embedding=true fillcolor={gray 0} fontsize=" . $this->mm2p(10) . " encoding=unicode leading=100% ";
        $this->centeredAndNotUnderlined = " alignment=center underline=false ";
        $this->centeredAndUnderlined = " alignment=center underline=true ";
*/

const styleDefinitions = {
    "sk-head": {
        fontSize: 24,
        bold: true,
        color: "#002ea7"
    },
    "sk-regular": {
        bold: false
    },
    "sk-bold": {
        bold: true
    },
    "sk-italic": {
        italics: true
    },
    header: {
        fontSize: 18,
        bold: true,
        margin: [0, 0, 0, 10],
        color: "#484a4f",
    },
    subheader: {
        fontSize: 16,
        bold: true,
        margin: [0, 10, 0, 5],
    },
    tableExample: {
        margin: [0, 5, 0, 15],
    },
    templateFooter: {
        margin: [0, 5, 0, 15]
    },
    tableHeader: {
        bold: false,
        fontSize: 10,
    },
    topHeadOptions: {
        bold: true,
        fontSize: 12,
        color: "#0155A6"
    },
    subHeadOptions: {
        bold: true,
        color: "#0155A6"
    },


    regularOptions: {
        bold: false,
        fontSize: 8,
        color: "black"
    },
    boldOptions: {
        bold: true,
        fontSize: 10,
        lineHeight: 1.2,
        color: "black"
    },
    boldOptionsCenteredUnderlined: {
        bold: true,
        fontSize: 10,
        lineHeight: 1.2,
        color: "black",
        decoration: 'underline',
        alignment: 'left'
    },
    smallBoldOptions: {
        bold: true,
        color: "black",
        fontSize: 8,
        lineHeight: 1.2
    },
    smallBoldOptionsCenteredUnderlined: {
        bold: true,
        color: "black",
        fontSize: 8,
        decoration: 'underline',
        alignment: 'left'
    },
    tableTextRegular: {
        bold: false,
        fontSize: 6,
        color: "black"
    },
    tableTextBold: {
        bold: true,
        fontSize: 6,
        color: "black"
    },
    tableTextGray: {
        bold: false,
        fontSize: 5.5,
        color: '#9B9B9B'
    },
    tableTextBlue: {
        bold: false,
        fontSize: 6,
        color: '#002ea7'
    }
}

export { styleDefinitions }